import React, { Component } from "react";
import { admission } from "../config/api";

import MetaTags from "react-meta-tags";
import axios from "axios";
import NewsList from "../Components/NewsList";

const LEVEL_LABEL = {
  "0": "ระดับหลักสูตรประกาศนียบัตรผู้ช่วยพยาบาล / ประกาศนียบัตรบัณฑิต",
  "1": "ระดับปริญญาตรี ภาคปกติ (กำแพงเพชรและแม่สอด)",
  "2": "ระดับปริญญาตรี ภาคกศ.บป. (กำแพงเพชรและแม่สอด)",
  "3": "ระดับบัณฑิตศึกษา",
  "4": "ระดับบัณฑิตศึกษา",
  "5": "ระดับหลักสูตรประกาศนียบัตรบัณฑิต",
};

export default class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      news: [],
    };
  }

  componentDidMount() {
    const param = this.props.match.params.param || "0";
    axios
      .get(
        admission + "/administrator_new/shownewsBee/" +
          param
      )
      .then((res) => {
        this.setState({ news: Array.isArray(res.data) ? res.data : [] });
      })
      .catch(() => {
        this.setState({ news: [] });
      });
  }

  render() {
    const param = this.props.match.params.param;
    const subtitle = LEVEL_LABEL[param] || "";

    return (
      <>
        <MetaTags>
          <title>ข่าวประชาสัมพันธ์ของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข่าวประชาสัมพันธ์ของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta
            property="og:title"
            content="ข่าวประชาสัมพันธ์ของระบบรับสมัครมหาวิทยาลัยราชภัฏกำแพงเพชร"
          />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>

        <NewsList items={this.state.news} subtitle={subtitle} pageLayout />
      </>
    );
  }
}
